import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Tooltip } from '@mui/material';
import {
    SimulationTypeEnum,
    SIMULATION_TYPE_COLORS,
} from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { camelize } from 'helpers/syntaxHelper';
import ColoredChip from 'ui/ColoredChip/ColoredChip';

type Props = {
    type: SimulationTypeEnum;
};

const StyChip = styled(ColoredChip, {
    name: 'StyChip',
})({
    height: '26px',
    fontSize: '13px',
});

const SimulationTypeChip = ({ type }: Props): React.ReactElement => {
    const { t } = useTranslation();

    const color = SIMULATION_TYPE_COLORS.color[type];
    const backgroundColor = SIMULATION_TYPE_COLORS.background[type];

    return (
        <Tooltip
            disableInteractive
            title={t(`humanResources.simulation.${camelize(type)}Explanation`)}
        >
            <Box sx={{ maxWidth: 'fit-content' }}>
                <StyChip
                    color={color}
                    backgroundColor={backgroundColor}
                    content={t(`humanResources.simulation.${camelize(type)}`)}
                />
            </Box>
        </Tooltip>
    );
};

export default SimulationTypeChip;
